export default "__VITE_ASSET__BZwf0SXX__"